import { useQuery } from '@apollo/client/react'
import type { ResultOf, VariablesOf } from '~publish/graphql'

import { GetChannelInfoForComments } from '../../SingleChannelView/fragments/getChannelInfoForComments'

/**
 * The single channel node produced by the comments single-channel query,
 * derived straight from the gql.tada document (composed fragments included) —
 * the shared "Channel" shape the single-channel view and its readers consume.
 */
export type GetChannelResult = ResultOf<
  typeof GetChannelInfoForComments
>['channel']

type GetChannelData = ResultOf<typeof GetChannelInfoForComments>
type GetChannelVariables = VariablesOf<typeof GetChannelInfoForComments>

export const useGetChannel = (
  channelId?: string,
): useQuery.Result<GetChannelData, GetChannelVariables> => {
  return useQuery(GetChannelInfoForComments, {
    variables: { channelId: channelId ?? '' },
    fetchPolicy: 'cache-and-network',
    skip: !channelId,
  })
}
